export const LeadTime24Hours = 24
export const LeadTime48Hours = 48
export const LeadTime72Hours = 72
